module.exports = __webpack_public_path__ + "assets/header-image.5d370687.svg";